module.exports = __webpack_public_path__ + "img/part_6_3.cc42a30c.webp";